<template>
    <div class="col-md-12">
        <div v-if="!installedPlugin">
            <div class="alert bg-orange alert-dismissible">
                <h5><b><i class="icon fa fa-exclamation-triangle"></i></b>
                    O plugin para leitura do certificado não está instalado, <a class="text-blue" href="#"
                        @click="redirectInstall()">
                        clique aqui para instalar.</a></h5>
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            </div>
        </div>
        <div v-if="installedPlugin">
            <div class="form-group">
                <label><i class="fa fa-certificate"></i> Escolha o certificado digital</label>
                <a class="float-right" href="https://armbd.com.br/" target="_blank"><i class="fa fa-info-circle"></i> Não tenho certificado</a>
                <div class="input-group">
                    <select v-model="request.certificate" id="certificateSelect" class="form-control">
                        <option :value="null">{{$t('words.select')}}</option>
                        <option v-for="(item, i) in certificadosProcessados" :value="item.id" :key="i">
                            {{item.subjectName}} (issued by {{item.issuerName}})</option>
                    </select>
                    <span class="input-group-btn"><button id="refreshButton" class="btn btn-default"><i
                                class="fa fa-refresh"></i></button></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LacunaWebPKI from 'web-pki';
    export default {
        props: {
            request: {}
        },
        data() {
            return {
                token: null,
                pki: {},
                installedPlugin: true,
                loading: false,
                selectedCert: {
                    documento: null,
                },
                certificados: []
            }
        },
        watch: {
            'token'(data) {
                this.request.token = data;
            }
        },
        computed: {
            certificadosProcessados() {
                let certs = [];
                this.certificados.map(item => {
                    let cert = {
                        id: this.createUUID(),
                        subjectName: item.subjectName,
                        issuerName: item.issuerName,
                        documento: item.pkiBrazil.isPessoaFisica ? item.pkiBrazil.cpf : item.pkiBrazil.cnpj,
                        thumbprint: item.thumbprint
                    }
                    certs.push(cert);
                });
                return certs;
            },
        },
        mounted() {
            this.pki = new LacunaWebPKI();
            console.log('Checking component installation ...');
            this.pki.init({
                ready: this.onWebPkiReady,
                notInstalled: this.onWebPkiNotInstalled,
                defaultError: this.onWebPkiError
            });
        },
        methods: {
            getDocument() {
                return this.certificadosProcessados.find( x => x.id === this.request.certificate).documento;
            },
            onWebPkiReady() {
                console.log('Component ready.');
                this.loadCertificates();
                this.installedPlugin = true;
                // ...
            },
            onWebPkiNotInstalled(message, error, origin) {
                /* alert(
                    'O plugin para leitura do certificado não está instalado. Você será redirecionado para a pagina de instalação automaticamente...'
                ); */
                this.installedPlugin = false;
                //this.pki.redirectToInstallPage();
                console.log('Installation NOT ok: ' + message);
            },
            onWebPkiError(message, error, origin) {
                console.log('Web PKI error originated at ' + origin + ': ' + error);
                toastr({
                    icon: 'error',
                    title: error
                });
                this.loading = false;
            },
            loadCertificates() {
                console.log('Listing certificates ...');
                this.pki.listCertificates().success(certificates => {
                    console.log('Certificates listed.');
                    this.certificados = certificates;
                });
            },
            redirectInstall() {
                this.pki.redirectToInstallPage();
            },
            sign() {
                let promise = new Promise((resolve, reject) => {
                    this.selectedCert = this.certificadosProcessados.find(x => x.id == this.request
                    .certificate);
                    this.pki.signWithRestPki({
                        token: this.token,
                        thumbprint: this.selectedCert.thumbprint
                    }).success(r => {
                        // Once the operation is completed, we submit the form.
                        resolve(r);
                    }).error(error => {
                        reject(error);
                    })
                });
                return promise;
            }
        }
    }
</script>